require('./bootstrap');

window.Vue = require('vue');
var numeral = require("numeral");


Vue.component('chart-list', require('./components/ChartList.vue'));

Vue.filter("formatNumber", function (value) {
	return numeral(value).format("0,0");
});


const app = new Vue({
    el: '#app'
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js